import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));

// Register service worker for PWA with auto-update
if ('serviceWorker' in navigator && location.hostname !== 'localhost') {
  window.addEventListener('load', async () => {
    try {
      const reg = await navigator.serviceWorker.register('/ngsw-worker.js');
      // Check for updates every 60s and on registration
      reg.addEventListener('updatefound', () => {
        const newSW = reg.installing;
        if (newSW) {
          newSW.addEventListener('statechange', () => {
            if (newSW.state === 'activated') {
              console.log('[SW] New version activated — reloading');
              window.location.reload();
            }
          });
        }
      });
      // Force update check on load
      reg.update().catch(() => {});
      // Periodic update check
      setInterval(() => reg.update().catch(() => {}), 60_000);
    } catch { /* SW registration failed */ }
  });
}
